import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import L from 'leaflet';
import { setAvoidSegmentPicking } from 'actions';
import { resolveRoadSegmentAtPoint } from '../../utils/roadSegmentResolver';
import { colors } from '../../global/variables';

const { avoidArea } = colors;

const AvoidSegmentPicking = ({ map, oAuth }) => {
  const dispatch = useDispatch();
  const active = useSelector((state) => state.avoidSegmentPicking.active);
  const highlightRef = useRef(null);

  useEffect(() => {
    if (!map || !active) return undefined;

    const clearHighlight = () => {
      if (highlightRef.current) {
        map.removeLayer(highlightRef.current);
        highlightRef.current = null;
      }
    };

    const onMapClick = (e) => {
      clearHighlight();
      highlightRef.current = L.circleMarker(e.latlng, {
        radius: 7,
        color: avoidArea,
        weight: 2,
        fillOpacity: 0.35,
        interactive: false,
      }).addTo(map);

      dispatch(setAvoidSegmentPicking({ status: 'loading', segment: null, error: null }));

      resolveRoadSegmentAtPoint(e.latlng, oAuth)
        .then((segment) => {
          dispatch(
            setAvoidSegmentPicking({ status: 'resolved', segment, direction: 'both', error: null }),
          );
        })
        .catch(() => {
          dispatch(
            setAvoidSegmentPicking({ status: 'error', segment: null, error: 'noSegmentFound' }),
          );
        });
    };

    map.on('click', onMapClick);

    return () => {
      map.off('click', onMapClick);
      clearHighlight();
    };
  }, [map, active, oAuth, dispatch]);

  return null;
};

export default AvoidSegmentPicking;
